"use strict";
// These styles are applied globally to any page that renders Chakra components. Modify only when necessary, and with great care.
// PHP app reset reference: `UI/templates/css/reset.less`
Object.defineProperty(exports, "__esModule", { value: true });
var primitives_1 = require("../primitives");
exports.default = {
    global: {
        '*, ::before, ::after': {
            borderColor: 'gray.300',
            boxSizing: 'border-box',
        },
        html: {
            fontSize: primitives_1.fontSize.md, // set rem value
        },
        body: {
            fontFamily: primitives_1.fontFamily.inter,
        },
        h1: {
            fontSize: primitives_1.fontSize['5xl'],
            fontWeight: primitives_1.fontWeight.bold,
        },
        h2: {
            fontSize: '22px',
            fontWeight: primitives_1.fontWeight.semiBold,
        },
        h3: {
            fontSize: primitives_1.fontSize.xl,
            fontWeight: primitives_1.fontWeight.semiBold,
        },
        h4: {
            fontSize: primitives_1.fontSize.md,
            fontWeight: 'revert',
        },
        h5: {
            fontSize: '13px',
            fontWeight: 'revert',
        },
        // force Chakra progress component to display as inline-flex, not inline-block
        'html .chakra-progress': {
            borderRadius: 'full',
            display: 'inline-flex',
        },
    },
};
